// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"285f860b","879":"098523f4"}[chunkId] + ".chunk.js";
};